export const CREATE_EXCLUSION = 'CREATE_EXCLUSION';
export const UPDATE_EXCLUSION = 'UPDATE_EXCLUSION';
export const REMOVE_EXCLUSION = 'REMOVE_EXCLUSION';

export function createExclusion(product) {
  return {
    type: CREATE_EXCLUSION,
    payload: {
      product,
    },
  };
}

export function updateExclusion(product, answer, order) {
  return {
    type: UPDATE_EXCLUSION,
    payload: {
      product,
      answer,
      order,
    },
  };
}

export function removeExclusion(product, exclusion) {
  return {
    type: REMOVE_EXCLUSION,
    payload: {
      product,
      exclusion,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/funnel/actions/exclusion.js